import { render, staticRenderFns } from "./Invent.vue?vue&type=template&id=6c5a5ed7&scoped=true&"
import script from "./Invent.vue?vue&type=script&lang=js&"
export * from "./Invent.vue?vue&type=script&lang=js&"
import style0 from "./Invent.vue?vue&type=style&index=0&id=6c5a5ed7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a5ed7",
  null
  
)

export default component.exports